import { addClass, removeClass } from "../util/misc";

export const doSubscribe = () => {
  const subscribeForm = document.querySelectorAll(".subscribeForm");
  if (!subscribeForm) return;
  subscribeForm.forEach((item) => {
    const button = item.querySelector(".subscribeButton");
    if (!button) return;
    button.addEventListener("click", (e) => _submitForm(e, item));
  });
};

const _submitForm = (e, parent) => {
  e.preventDefault();
  const input = parent.querySelector("#subscribeInput");
  const responseField = parent.querySelector("#subscribeResponseId");
  if (!input || _isValidEmail(input.value, responseField)) return;

  const data = {
    members: [
      {
        email_address: input.value,
        status: "pending",
      },
    ],
  };

  _postData(data, responseField, parent);
};

function _isValidEmail(email, errorField) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (email == "" || !re.test(String(email).toLowerCase())) {
    removeClass(errorField, "hidden");
    addClass(errorField, "text-red-600");
    errorField.innerHTML = "Invalid input, please enter a valid email.";
  } else {
    addClass(errorField, "hidden");
  }
}

function _postData(data = {}, responseField, parent) {
  const submitButton = parent.querySelector(".subscribeButton");
  const oldButtonText = submitButton.value;
  submitButton.setAttribute("disabled", true);
  submitButton.value = "Loading...";

  // @todo: extract to .env or call from backend
  const listId = "0d329e9378";
  const dataCenter = "us4";
  const API_KEY = "2b4a61e04b45d5d9d7436bd913ee62de-us4";

  // const testDataCenter = "us19"
  // const testListId = "fad98db527";

  fetch(
    "https://cors-anywhere.herokuapp.com/" +
      `https://${dataCenter}.api.mailchimp.com/3.0/lists/${listId}`,
    {
      method: "POST",
      mode: "cors",
      headers: {
        Authorization: "Basic " + API_KEY,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify(data),
    }
  )
    .then((response) => response.json())
    .then((data) => _onResponse(data, responseField, parent, oldButtonText));
}

function _onResponse(res, responseField, parent, oldButtonText) {
  const submitButton = parent.querySelector(".subscribeButton");
  const input = parent.querySelector("#subscribeInput");
  input.value = "";
  submitButton.value = oldButtonText;
  submitButton.setAttribute("disabled", false);

  if (!res) return;
  if (res.error_count === 0) {
    // show success
    removeClass(responseField, "hidden");
    addClass(responseField, "text-green-700");
    responseField.innerHTML =
      "Success, please check your mail to confirm action";
    setTimeout(() => {
      responseField.innerHTML = null;
      addClass(responseField, "hidden");
    }, 2000);
  } else if (res.error_count === 1) {
    // show error
    removeClass(responseField, "hidden");
    addClass(responseField, "text-red-600");
    responseField.innerHTML = res.errors[0].error;
    setTimeout(() => {
      responseField.innerHTML = null;
      addClass(responseField, "hidden");
    }, 2000);
  } else {
    // show error
    removeClass(responseField, "hidden");
    addClass(responseField, "text-red-600");
    responseField.innerHTML = "Something went wrong, please try again";
    setTimeout(() => {
      responseField.innerHTML = null;
      addClass(responseField, "hidden");
    }, 2000);
  }
}



// WEBPACK FOOTER //
// ./scripts/sections/subscribe.js